const header = document.querySelector('[js-header]')
const items = document.querySelectorAll('[js-nav-item]')
const itemsOut = document.querySelectorAll('[js-nav-out]')
const submenu = document.querySelectorAll('[js-nav-submenu]')
const bkg = document.querySelector('[js-header-bkg]')
let timer = null
let activeIndex = null

if (items && items.length > 0) {
  items.forEach((item, index) => {
    item.addEventListener('mouseover', () => {
      if (activeIndex !== index) { 
        activeIndex = index
        if ( document.querySelector('[js-nav-submenu].is-open')) {
          document.querySelector('[js-nav-submenu].is-open').style = ''
          document.querySelector('[js-nav-submenu].is-open').classList.remove('is-open')
        }
        if(document.querySelector('[js-nav-item].is-active')) document.querySelector('[js-nav-item].is-active').classList.remove('is-active')

        const activeMenu = submenu[index]
        activeMenu.classList.add('is-open')
        clearTimeout(timer)
        item.classList.add('is-active')
        if (!bkg.classList.contains('is-open')) {
          header.classList.add('with-bkg')
          bkg.classList.add('is-open')
        }

        timer = setTimeout(() => {
          bkg.style.opacity = 1
          bkg.style.height = `${activeMenu.offsetHeight + 112}px`
        }, 100)

        timer = setTimeout(() => {
          activeMenu.style.opacity = 1
        }, 400)
      }
    })
  })
}

if (header) {
  header.addEventListener('mouseleave', () => {
    bkg.style = ''
    bkg.style.height = `${ header.classList.contains('is-sticky') ? 72 : 0}px`
    bkg.classList.remove('is-open')
    header.classList.remove('with-bkg')
    if ( document.querySelector('[js-nav-submenu].is-open')) {
      document.querySelector('[js-nav-submenu].is-open').style = ''
      document.querySelector('[js-nav-submenu].is-open').classList.remove('is-open')
    }

    if(document.querySelector('[js-nav-item].is-active')) document.querySelector('[js-nav-item].is-active').classList.remove('is-active')


    clearTimeout(timer)
    
    timer = setTimeout(() => {
      bkg.style = ''
      activeIndex = null
    }, 300)
  })
}

if (itemsOut && itemsOut.length) {
  itemsOut.forEach((item,index) => {
    item.addEventListener('mouseover', () => {
      bkg.style = ''
      bkg.style.height = `${ header.classList.contains('is-sticky') ? 72 : 0}px`
      bkg.classList.remove('is-open')
      header.classList.remove('with-bkg')

      if ( document.querySelector('[js-nav-submenu].is-open')) {
        document.querySelector('[js-nav-submenu].is-open').style = ''
        document.querySelector('[js-nav-submenu].is-open').classList.remove('is-open')
      }
      if(document.querySelector('[js-nav-item].is-active')) document.querySelector('[js-nav-item].is-active').classList.remove('is-active')
      clearTimeout(timer)
      
      timer = setTimeout(() => {
        bkg.style = ''
        activeIndex = null
      }, 300)
    })
  })
}
